// extracted by mini-css-extract-plugin
export default {"cls1":"QywTjrZ5_HebG0RAghgr","cls2":"a4HfDfZ_vdMdf8n7aJYH QywTjrZ5_HebG0RAghgr"};